<app-modal>
  <app-modal-title>{{ (isEditMode ? 'modal.edit-tag.title.edit' : 'modal.edit-tag.title.create') | translate }}</app-modal-title>
  <app-modal-body>
    <div class="-mx-6" [formGroup]="form">
      <p class="text-sm text-error-500" *ngIf="error">{{ 'modal.edit-tag.error' | translate}}</p>

      <app-form-group label="{{ 'modal.edit-tag.input.name' | translate }}">
        <app-input formControlName="name" placeholder="{{ 'modal.edit-tag.input.name.placeholder' | translate }}"></app-input>
      </app-form-group>

      <app-form-group label="{{ 'modal.edit-tag.input.color' | translate }}">
        <app-input type="color" formControlName="color" placeholder="{{ 'modal.edit-tag.input.color.placeholder' | translate }}"></app-input>
      </app-form-group>

      <app-form-group label="{{ 'modal.edit-tag.input.icon' | translate }}">
        <app-file-upload [loadImageFunction]="loadImage" formControlName="icon" placeholder="{{ 'modal.edit-tag.input.icon.placeholder' | translate }}"></app-file-upload>
      </app-form-group>
    </div>
  </app-modal-body>
  <app-modal-footer>
    <app-button text="{{ 'modal.edit-tag.cancel' | translate }}" variant="plain" (click)="close()"></app-button>
    <app-button text="{{ 'modal.edit-tag.save' | translate }}" [loading]="loading" (click)="save()"></app-button>
  </app-modal-footer>
</app-modal>
